import { combineReducers } from "redux";
import { ACTION } from "./constants";

const initialState = { isLoading: false };

export default function goalMarketingReducer(state = initialState, action) {
  switch (action.type) {
    case ACTION.GOAL_MARKETING:
      return { ...state, GoalMarketingData: action.data };
    case ACTION.GOAL_VIDEO_PODCAST_BLOG:
      return { ...state, GoalVideoPodcastBlogData: action.data };
      
    default:
      return state;
  }
}
